const NUMERIC = (val) => {

  return (val.match(/^[0-9]+$/))?true:false;

}


export { NUMERIC };